import React from 'react'

import close_icon from '../../../assets/images/icons/close-icon.png'
import SubmitButton from '../../../components/loadingButton/modelSubmitButton';
import CancelButton from '../../../components/loadingButton/modelCancelButton';







const Pay = (props)=>{

    const {paymentDetails} = props
    
    return(
        <div className="model-body">
            <div className="d-flex model-title">
              <span>{props.title}</span>
              <div 
                className="d-flex close-ctn"
                onClick={props.hide}>
                  <span>close</span>
                  <img src={close_icon}/>
              </div>
            </div>
            <br/>
           <div style={{
               width: '100%',
               display: 'flex',
               justifyContent: 'center',
               flexDirection: 'column',
               alignItems: 'center'
           }}
            className="mb-4">
               <span  className="dashboard-green-text-header">Thank You, </span>
                <span className="dashboard-green-text-header mb-4">for filling the application requirements </span>
                <span style={{textAlign: 'center'}} className="general-span-text-none-auto">Please proceed to pay the application fee of <br/>
                <span style={{color: '#FF0000', fontSize: 40}}>{paymentDetails?.amount} RWF <br/>
                </span>for your application bill ID: {paymentDetails?.id} </span>
           </div>

          {props.paymentMethod !=='VISA' ? <div>
                <div className="payment-model-input-filied">
                        <input 
                            placeholder={`Enter ${props.paymentMethod} phone number to pay with `}
                            onChange={(text)=>props.handlePhoneNumber(text)}
                            type="number"/>
                </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <span className="please-make-sure-text">
                        {`Please make sure you have enough money`}<br/>
                        {`on the ${props.paymentMethod} ${props.paymentMethod === 'MTN' ? 'Mobile' : ''} Money phone number you entered`}
                        </span>
                    </div>
           </div> : 
            <div>
                <div className="visa-payment-container mb-4">
                    <span>Card number</span>
                    <div className="visa-payment-input">
                        <input placeholder="#### #### ###"/>
                    </div>
                </div>
                <div className="visa-payment-container">
                    <div className="d-flex ccv-expires-ctn">
                        <div style={{marginRight: 40}}>
                            <span>CVV</span>
                            <div className="ccv-input">
                                <input placeholder="####"/>
                            </div>
                        </div>
                        <div style={{flex: '1'}}>
                            <span>Exipres on</span>
                            <div className="expires-on">
                                <input type="date"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <span className="please-make-sure-text">
                        Please make sure you have enough money <br/>
                        on your Card
                        </span>
                    </div>
            </div>
           }

        <div className="model-footer-buttons mt-4">
            <CancelButton
                title="PAY LATER"
                submit={props.cancel}/>
            <SubmitButton
                title="PAY NOW"
                submit={props.submit}
                disabled={props.loader && props.loader.isLoading}
                />
        </div>
          </div> 
    )
}

export default Pay